import { logoClick } from './logo'
import { headerSticky } from './headerSticky'

document.addEventListener('DOMContentLoaded', () => {
  logoClick()
  headerSticky()
})
